export const FormatDateShortMonth = (dateString) => {
  const date = new Date(dateString);
  const day = date.getUTCDate().toString().padStart(2, "0");
  const month = date.toLocaleString("en-US", {
    month: "short",
    timeZone: "UTC",
  });
  const year = date.getUTCFullYear();

  return `${month}-${day}-${year}`;
};

const getFormatedDate = (dateValue) => {
  const DateValue = new Date(dateValue);
  const shortMonth = DateValue.toLocaleString("en-US", {
    month: "short",
  });
  const day = DateValue.toLocaleString("en-US", {
    day: "numeric",
  });
  const year = DateValue.toLocaleString("en-US", {
    year: "numeric",
  });
  const finaldate = shortMonth + "-" + day + "-" + year;
  return finaldate;
};
export default getFormatedDate;

export function convertGMTToLocal(gmtString) {
    return new Date(gmtString);  
}
